@use "themes/code-theme-light";
@use "themes/code-theme-dark";

.ux-code {
  box-sizing: border-box;
  display: block;
  margin: 0 auto;
  position: relative;

  &__copy {
    padding: 0.25em;
    position: absolute;
    right: 0;
    top: 0;

    &-btn {
      background: rgb(255 255 255 / 75%);
      border: 0 none transparent;
      border-radius: 0.25em;
      box-shadow: 0 0 0.25em rgb(0 0 0 / 10%);
      color: #000;
      cursor: pointer;
      display: inline-block;
      font-size: 14px;
      padding: 0.5em 0.75em;
    }

    .ux-icon {
      fill: currentcolor;
      margin-left: 0.5em;
    }
  }

  code,
  pre {
    font-family: monospace;
    font-size: 14px;
    font-weight: normal;
    hyphens: none;
    line-height: 1.5;
    tab-size: 4;
    text-align: left;
    white-space: pre;
    word-break: normal;
    word-spacing: normal;
    word-wrap: normal;
  }

  pre {
    margin: 0;
    overflow: auto;
    padding: 1em;
  }

  &--line-numbers pre {
    padding-left: 3em;
  }

  &__rows {
    background: #f3f3f3;
    left: 0;
    padding: 1em 0.5em;
    position: absolute;
    top: 0;

    > span {
      display: block;
      opacity: 0.5;
    }
  }

  &--theme-dark {
    .ux-code__copy-btn {
      background: transparent;
      color: #fff;
    }

    .ux-code__rows {
      background: #2c2c2c;
    }
  }

  pre::selection,
  pre ::selection,
  code::selection,
  code ::selection {
    background: #b3d4fc;
    color: #000;
    text-shadow: none;
  }

  &--inline {
    display: inline;

    pre {
      display: inline;
      padding: 0.2em 0.4em;
    }
  }
}
